import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

class CompetitorComparison extends HTMLElement {
  /** @type {HTMLElement | null} */
  #section = null;

  connectedCallback() {
    this.#section = /** @type {HTMLElement | null} */ (this.closest('.shopify-section, dialog'));
    this.#section?.addEventListener(ThemeEvents.variantUpdate, /** @type {EventListener} */ (this.#updatePrice));
    this.#sortCompetitorColumns();
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(ThemeEvents.variantUpdate, /** @type {EventListener} */ (this.#updatePrice));
    this.#section = null;
  }

  #sortCompetitorColumns() {
    const table = /** @type {HTMLTableElement | null} */ (this.querySelector('.competitor-comparison__table'));
    const headerRow = table?.querySelector('thead tr');

    if (!table || !headerRow || !table.querySelector('[data-comparison-price-row]')) return;

    const competitorHeaders = Array.from(headerRow.querySelectorAll('[data-competitor-index]'));
    competitorHeaders.sort((left, right) => {
        const leftPriceValue = left.getAttribute('data-competitor-price');
        const rightPriceValue = right.getAttribute('data-competitor-price');
        const leftPrice = Number(leftPriceValue);
        const rightPrice = Number(rightPriceValue);
        const leftHasPrice = leftPriceValue !== null && Number.isFinite(leftPrice);
        const rightHasPrice = rightPriceValue !== null && Number.isFinite(rightPrice);

        if (leftHasPrice && rightHasPrice) return leftPrice - rightPrice;
        if (leftHasPrice) return -1;
        if (rightHasPrice) return 1;
        return 0;
    });
    const orderedIndices = competitorHeaders
      .map((header) => header.getAttribute('data-competitor-index'))
      .filter((index) => index !== null);

    for (const row of table.rows) {
      for (const competitorIndex of orderedIndices) {
        const cell = Array.from(row.cells).find((item) => item.getAttribute('data-competitor-index') === competitorIndex);
        if (cell) row.append(cell);
      }
    }
  }

  /** @param {VariantUpdateEvent} event */
  #updatePrice = (event) => {
    const productChanged = Boolean(
      event.detail.data.newProduct && event.detail.data.newProduct.id !== this.dataset.productId
    );

    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newComparison = Array.from(event.detail.data.html.querySelectorAll('competitor-comparison')).find(
      (comparison) => comparison.getAttribute('data-block-id') === this.dataset.blockId
    );

    if (!productChanged) {
      const newTable = newComparison?.querySelector('.competitor-comparison__table');
      const currentTable = this.querySelector('.competitor-comparison__table');

      if (newTable && currentTable) {
        currentTable.replaceWith(newTable.cloneNode(true));
        this.#sortCompetitorColumns();
      }
      return;
    }

    if (newComparison) {
      this.replaceWith(newComparison.cloneNode(true));
    } else {
      this.replaceChildren();
      this.hidden = true;
      this.dataset.comparisonState = 'empty';
      this.dataset.usableColumns = '0';
    }
  };
}

if (!customElements.get('competitor-comparison')) {
  customElements.define('competitor-comparison', CompetitorComparison);
}
